/**
 * Tooltip text for the in-progress year's "(to date)" axis label on the
 * timeline charts: the date the dataset was last synced from upstream.
 *
 * `lastUpdated` is the ISO stamp every incidents API response carries (set
 * by /api/sync on each successful pull). Formatted in UTC, the zone the
 * stamp is written in, with the month spelled out so the date can't be read
 * day-first or month-first. Null when the stamp is missing or unparseable,
 * so the label simply shows no tooltip rather than "Invalid Date".
 */
export function lastUpdatedText(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const date = d.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
  return `Last updated on: ${date}`;
}
